import { WebPlugin } from '@capacitor/core';
export class CapacitorWifiWeb extends WebPlugin {
    async checkPermission() {
        return Promise.resolve({ status: false });
    }
    ;
    requestPermission() {
        console.error("Not implemented in web");
    }
    ;
    wifiScan() {
        console.warn("Not implemented in web, returning a mock");
        return Promise.resolve({ networks: [{
                    BSSID: "aa:bb:cc:dd:ee:ff",
                    SSID: "Test SSID",
                    capabilities: "example",
                    centerFreq0: 80,
                    centerFreq1: 80,
                    frequency: 0,
                    level: 20,
                    timestamp: 20
                },
                {
                    BSSID: "aa:bb:cc:dd:ee:fx",
                    SSID: "Test 2 SSID",
                    capabilities: "example",
                    centerFreq0: 80,
                    centerFreq1: 80,
                    frequency: 0,
                    level: 20,
                    timestamp: 20
                }], error: "Not implemented in web" });
    }
    ;
    getWifiStatus() {
        console.error("Not implemented in web");
        return Promise.resolve({ status: false });
    }
    getSupportedBands() {
        throw new Error("Not implemented in web");
    }
    ;
    changeWifiStatus() {
        console.error("Not implemented in web");
        return Promise.resolve({ status: true });
    }
    ;
    disconnect() {
        console.error("Not implemented in web");
        return Promise.resolve({ status: true });
    }
    ;
    getCurrentNetworkConfiguration() {
        throw new Error("Not implemented in web");
    }
    ;
    getDHCPInfo() {
        throw new Error("Not implemented in web");
    }
    ;
    isP2PSupported() {
        return Promise.resolve({ p2p_supported: true });
    }
    ;
}
//# sourceMappingURL=web.js.map